import type { Bytes, StringGUID, Time } from "@pdfking/tfunc"

import type { MetaFile } from "../base/MetaFile"
import type { ContentType } from "../ContentType"
import type { VirtualFileType } from "../VirtualFileType"

export type GeneratedFile = {
  readonly enum: VirtualFileType.GENERATED_FILE
  readonly guid: StringGUID
  readonly type: ContentType
  readonly size: Bytes
  readonly modified: Time
} & MetaFile
